import { Box, Typography } from '@mui/material';

export const LoginError = ({ message }) => (
  <Box
    sx={{
      backgroundColor: '#ffebee',
      border: '1px solid #ffcdd2',
      borderRadius: '4px',
      padding: '12px',
      marginTop: '16px',
      marginBottom: '16px',
    }}
  >
    <Typography
      variant="body2"
      sx={{
        color: '#c62828',
        fontSize: '14px',
        textAlign: 'center',
      }}
    >
      {message}
    </Typography>
  </Box>
);
